// extracted by mini-css-extract-plugin
module.exports = {"section_prospect":"prospects_section_prospect__lWyHQ","sub_title":"prospects_sub_title__BmnA_","link":"prospects_link__4BI9u","image_wrapper":"prospects_image_wrapper__AP_2y"};